import React from 'react';
import { AlertCircle, Clock, RefreshCw, BarChart2 } from 'lucide-react';

const RateLimitAlert = ({ 
  remainingTime, 
  onRetry,
  rateLimits = {
    requests: { limit: 0, remaining: 0, reset_seconds: 0 },
    tokens: { limit: 0, remaining: 0, reset_seconds: 0 }
  }
}) => {
  const formatTime = (seconds) => {
    if (seconds < 60) return `${Math.ceil(seconds)}s`;
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.ceil(seconds % 60);
    return `${minutes}m ${remainingSeconds}s`;
  };

  return (
    <div className="w-full max-w-2xl mx-auto">
      <div className="bg-amber-50 border-l-4 border-amber-400 p-6 rounded-lg shadow-sm">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <AlertCircle className="h-6 w-6 text-amber-400" />
          </div>
          
          <div className="ml-3 w-full">
            <h3 className="text-lg font-medium text-amber-800">
              Rate Limit Reached
            </h3>
            
            <div className="mt-2">
              <p className="text-sm text-amber-700">
                We've reached the maximum number of requests allowed. Please wait a moment before trying again.
              </p>

              {/* Rate Limits Information */}
              <div className="mt-4 bg-amber-100/50 rounded-lg p-4">
                <h4 className="text-sm font-medium text-amber-800 flex items-center mb-3">
                  <BarChart2 className="h-4 w-4 mr-1" />
                  Current Limits Status
                </h4>
                
                {/* Requests Limit */}
                <div className="mb-3">
               
                  {/* Requests Limit */}
                    <div className="mb-3">
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-sm text-amber-700">Requests</span>
                        <span className="text-xs text-amber-600">
                          {rateLimits.requests.remaining} / {rateLimits.requests.limit}
                        </span>
                      </div>
                      <div className="w-full bg-amber-200 rounded-full h-1.5">
                        <div
                          className="bg-amber-500 h-1.5 rounded-full transition-all duration-500"
                          style={{
                            width: `${(rateLimits.requests.remaining / rateLimits.requests.limit) * 100}%`
                          }}
                        />
                      </div>
                     
                    </div>

                    {/* Tokens Limit */}
                    <div>
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-sm text-amber-700">Tokens</span>
                        <span className="text-xs text-amber-600">
                          {rateLimits.tokens.remaining} / {rateLimits.tokens.limit}
                        </span>
                      </div>
                      <div className="w-full bg-amber-200 rounded-full h-1.5">
                        <div
                          className="bg-amber-500 h-1.5 rounded-full transition-all duration-500"
                          style={{
                            width: `${(rateLimits.tokens.remaining / rateLimits.tokens.limit) * 100}%`
                          }}
                        />
                      </div>
                      <div className="text-xs text-amber-600 mt-1">
                        Resets in: {formatTime(rateLimits.tokens.reset_seconds)}
                      </div>
                    </div>
                </div>

              </div>
              
              {/* Retry Timer Section */}
              <div className="mt-4 flex items-center justify-between">
                <div className="flex items-center text-sm text-amber-600">
                  <Clock className="h-4 w-4 mr-1" />
                  <span>Retry available in: {Math.ceil(remainingTime / 1000)}s</span>
                </div>
                
                <button
                  onClick={onRetry}
                  disabled={remainingTime > 0}
                  className={`
                    inline-flex items-center px-4 py-2 rounded-md text-sm font-medium
                    ${remainingTime > 0 
                      ? 'bg-amber-100 text-amber-400 cursor-not-allowed'
                      : 'bg-amber-100 text-amber-700 hover:bg-amber-200 transition-colors'}
                  `}
                >
                  <RefreshCw className={`h-4 w-4 mr-1 ${remainingTime > 0 ? '' : 'animate-spin'}`} />
                  Retry Now
                </button>
              </div>
              
              <div className="mt-3 w-full bg-amber-200 rounded-full h-1">
                <div
                  className="bg-amber-400 h-1 rounded-full transition-all duration-1000 ease-out"
                  style={{
                    width: `${(1 - remainingTime / (rateLimits.requests.reset_seconds * 1000)) * 100}%`
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RateLimitAlert;